{
  "zh-TW": {
    "headlines": {
      "admin": {
        "dashboard": {
          "title": "儀表板",
          "modelsByClassification": "按分類整理",
          "models": "已重新載入型號",
          "modelsByManufacturer": "按製造商分類",
          "manufacturers": "製造商",
          "modelsByStatus": "按狀態分類型號",
          "modelsBySize": "按尺寸分類",
          "modelsPerMonth": "每月型號",
          "componentsByClass": "按類別分組件",
          "components": "組件",
          "visitsPerDay": "每日訪問",
          "visitsPerMonth": "每月訪問",
          "mostViewedPages": "瀏覽最多的頁面",
          "registrationsPerMonth": "每月註冊數",
          "users": "使用者"
        },
        "models": {
          "index": "型號",
          "edit": {
            "index": "編輯型號",
            "fleetchart": "艦隊圖表圖片",
            "positions": "乘員位置",
            "hardpoints": "掛載點",
            "cargoAndFuel": "燃料",
            "cargoHolds": "貨艙",
            "metrics": "指標",
            "prices": "價格",
            "docks": "停靠口",
            "modules": "模組",
            "paints": "塗裝",
            "videos": "影片",
            "images": "圖片",
            "itemPrices": "物品價格",
            "linkModule": "連結現有模組",
            "loaners": "借用船",
            "snubCrafts": "艦載小艇",
            "upgrades": "升級",
            "packages": "套餐",
            "linkUpgrade": "連結現有升級",
            "history": "歷史記錄"
          },
          "new": "新型號",
          "show": "型號",
          "images": "圖片",
          "tableConfigurationModal": "表格設定"
        },
        "components": {
          "index": "組件",
          "new": "新組件",
          "edit": {
            "index": "編輯組件",
            "itemPrices": "物品價格",
            "history": "歷史記錄"
          }
        },
        "modelPaints": {
          "index": "塗裝",
          "new": "新塗裝",
          "edit": "編輯塗裝",
          "copy": "複製塗裝至飛船",
          "bulkCopy": "複製 %{count} 個塗裝至飛船"
        },
        "modelModules": {
          "index": "模組",
          "new": "新模組",
          "edit": "編輯模組",
          "models": "關聯型號",
          "prices": "價格",
          "hardpoints": "掛載點",
          "cargoHolds": "貨艙",
          "history": "歷史記錄"
        },
        "unlistedModels": {
          "index": "遊戲檔案中沒有對應條目的飛船",
          "link": "關聯到目錄中的飛船"
        },
        "manufacturers": {
          "index": "製造商",
          "new": "新製造商",
          "edit": {
            "index": "編輯製造商"
          }
        },
        "supporterContributions": {
          "index": "支持者貢獻",
          "new": "新增支持者貢獻",
          "edit": "編輯支持者貢獻",
          "perMonth": "每月貢獻"
        },
        "fundingGoals": {
          "index": "資金目標",
          "new": "新增資金目標",
          "edit": "編輯資金目標"
        },
        "users": {
          "index": "使用者",
          "edit": "編輯使用者",
          "fleets": "艦隊",
          "inventories": "庫存"
        },
        "vehicles": {
          "index": "載具",
          "edit": "編輯載具"
        },
        "fleets": {
          "index": "艦隊",
          "edit": "編輯艦隊",
          "members": "成員",
          "memberEdit": "編輯成員",
          "history": "歷史記錄",
          "roles": "角色",
          "inventories": "庫存",
          "inventoryItems": "庫存記錄"
        },
        "destroyedFleets": {
          "index": "已刪除艦隊"
        },
        "admins": {
          "index": "管理員",
          "new": "新管理員",
          "edit": "編輯管理員"
        },
        "oauthApplications": {
          "index": "OAuth 應用程式",
          "new": "新增 OAuth 應用程式",
          "edit": "編輯 OAuth 應用程式"
        },
        "features": {
          "index": "功能標誌",
          "show": "功能詳情",
          "globalState": "全域狀態",
          "groups": "群組",
          "actors": "角色",
          "selfService": "自助服務",
          "percentageOfActors": "角色百分比",
          "percentageOfTime": "時間百分比",
          "addActor": "新增角色"
        },
        "rsiApiStatus": {
          "index": "RSI API 狀態"
        },
        "images": {
          "index": "圖片"
        },
        "imports": {
          "index": "匯入"
        },
        "notifications": {
          "index": "通知"
        },
        "commodities": {
          "index": "Commodities",
          "new": "New Commodity",
          "edit": {
            "index": "Edit Commodity"
          }
        },
        "equipment": {
          "index": "Equipment",
          "new": "New Equipment",
          "edit": {
            "index": "Edit Equipment",
            "itemPrices": "Item Prices"
          }
        },
        "visualTests": {
          "index": "視覺測試",
          "notifications": "通知"
        },
        "buildCompare": {
          "index": "版本比較"
        }
      },
      "welcome": "Welcome to",
      "welcomeShips": "Latest Ships",
      "welcomeImages": "Random Images",
      "ships": {
        "index": "Ships Index",
        "fleetchart": "飛船艦隊圖表"
      },
      "images": "Images Index",
      "stats": "統計",
      "notFound": "導航錯誤",
      "forbidden": "拒絕存取",
      "featureNotReady": "即將推出",
      "accessDenied": "拒絕存取",
      "serverError": "伺服器錯誤",
      "comments": "評論",
      "login": "登入",
      "hangar": {
        "index": "我的機庫",
        "preview": {
          "h1": "我的機庫預覽",
          "h2": "Your personal Hangar requires an FleetYards.net Account",
          "h3": "What Features does the Hangar include?"
        },
        "alternativeNames": "別名",
        "stats": "統計",
        "public": "%{user} 的機庫",
        "import": "匯入",
        "wishlist": "願望清單",
        "publicStats": "統計",
        "publicWishlist": "%{user} 的願望清單",
        "resetIngame": "資料重置後重設遊戲內飛船"
      },
      "syncExtension": "同步 RSI 機庫",
      "editMyVehicle": "Edit my %{vehicle}",
      "nameMyVehicle": "Name my %{vehicle}",
      "editGroups": "Edit Groups",
      "newVehicles": "Add Ships",
      "myVehicleAddons": "Add Modules / Upgrades for %{vehicle}",
      "myVehicleLoadouts": "%{vehicle} 的裝配",
      "addToHangar": "Add \"%{model}\" to your Hangar",
      "impressum": "法律聲明",
      "privacy": "隱私政策",
      "cookie": "Cookie policy",
      "requestPassword": "請求密碼",
      "changePassword": "變更密碼",
      "confirmAccess": "Confirm access",
      "setEmail": "設定電子郵件地址",
      "oauthAuthorize": "授權應用程式",
      "filterModels": "Filter Ships",
      "filterVehicles": "Filter Hangar",
      "fleets": {
        "owners": "Owners",
        "add": "Create a new Fleet",
        "invites": "艦隊邀請",
        "inviteUrls": "Invite Urls",
        "members": {
          "index": "Members",
          "worldmap": "成員世界地圖",
          "starmap": "成員星圖"
        },
        "stats": "統計",
        "preview": {
          "h1": "艦隊預覽",
          "h2": "To create a Fleet you need to have a FleetYards.net Account",
          "h3": "What Features does your Fleet include?"
        },
        "settings": {
          "fleet": "Fleet Settings",
          "membership": "Membership Settings",
          "roles": "艦隊角色",
          "notifications": "通知設定",
          "inAppNotifications": "應用內通知",
          "discord": "Discord",
          "calendar": "行事曆",
          "features": "艦隊功能"
        },
        "inviteMember": "Invite new Member",
        "calendarSubscription": "行事曆訂閱",
        "missions": {
          "index": "任務",
          "create": "建立任務",
          "edit": "編輯任務",
          "editBasic": "基本資訊",
          "editDescription": "描述與封面",
          "editTeams": "小隊與席位",
          "teams": "小隊",
          "ships": "飛船",
          "slots": "席位",
          "addTeam": "新增小隊",
          "editTeam": "編輯小隊",
          "addShip": "新增飛船",
          "editShip": "編輯飛船"
        },
        "events": {
          "index": "活動",
          "calendar": "行事曆",
          "create": "建立活動",
          "edit": "編輯活動",
          "editBasic": "基本資訊",
          "editDescription": "描述與封面",
          "editTeams": "小隊與席位",
          "spawn": "產生活動",
          "details": "活動詳情",
          "schedule": "排程",
          "settings": "設定",
          "lifecycle": "生命週期",
          "signupTitle": "我要報名",
          "yourSignup": "你的報名",
          "spawnedFrom": "由此任務產生",
          "pickTemplate": "選擇任務範本",
          "unassignedSignups": "未分配的報名",
          "eventTeam": "活動小隊",
          "grantRole": "授予角色",
          "editTeam": "編輯小隊",
          "addTeam": "新增小隊",
          "editShip": "編輯飛船",
          "addShip": "新增飛船",
          "assignSlotFor": "為 %{username} 分配席位",
          "reassignSlotFor": "為 %{username} 重新分配席位"
        }
      },
      "hangarGroup": {
        "create": "Create Group",
        "edit": "Edit Group"
      },
      "compare": {
        "ships": "比較飛船"
      },
      "settings": {
        "account": "帳戶",
        "profile": "個人資料設定",
        "hangar": "機庫設定",
        "privacy": "隱私設定",
        "features": "功能標誌",
        "connections": "連線",
        "oauthApplications": "OAuth 應用程式",
        "notifications": "通知設定",
        "verify": "Verify your RSI Account",
        "security": {
          "index": "帳戶安全",
          "twoFactor": "Two-factor Authentiation"
        },
        "twoFactor": {
          "enable": "Enable Two-factor Authentiation",
          "disable": "Disable Two-factor Authentiation",
          "backupCodes": "Generate Two-Factor Backup Codes"
        },
        "calendar": "行事曆訂閱"
      },
      "oauthApplications": {
        "new": "新增 OAuth 應用程式",
        "edit": "編輯 OAuth 應用程式"
      },
      "roadmap": "飛船路線圖",
      "tools": {
        "index": "工具",
        "travelTimes": "旅行時間",
        "cargoGrids": "貨物網格",
        "profitCalculator": {
          "index": "Profit Calculator"
        },
        "tradeRoutes": {
          "index": "Trade Routes",
          "withShip": "Trade Routes for %{name} (%{cargo})"
        }
      },
      "rsiVerification": "Verify your RSI-Account",
      "hangarGuideEmpty": "Not much to see here?",
      "hangarGuide": "Hangar Guide",
      "support": "Support FleetYards.net",
      "supporters": "感謝我們的支持者",
      "supportHint": {
        "hangarSync": "很高興能幫你完成同步",
        "vehicleAdded": "你的機庫在不斷成長",
        "fleetCreated": "新艦隊 — 恭喜!",
        "loginMilestone": "感謝你一直以來的支持",
        "visitMilestone": "喜歡 FleetYards 嗎?"
      },
      "vehicle": {
        "bulkGroupEdit": "新增/移除群組"
      },
      "pagination": {
        "count": "%{current} / %{total}"
      },
      "models": {
        "index": "型號"
      },
      "modals": {
        "models": {
          "displayOptions": "顯示選項"
        },
        "shopCommodity": {
          "update": "Update Commodity %{shopCommodity}",
          "create": "Add Commodity",
          "sellPrices": "%{shopCommodity} Sell Prices",
          "buyPrices": "%{shopCommodity} Buy Prices",
          "rentalPrices": "%{shopCommodity} Rental Prices"
        },
        "commodityPrice": {
          "create": "Submit Price"
        }
      },
      "visualTests": {
        "overview": "概覽",
        "panels": "面板",
        "buttons": "按鈕",
        "media": "媒體",
        "charts": "圖表",
        "chips": "視覺測試 Chips",
        "events": "活動",
        "typography": "排版",
        "forms": "表單",
        "tables": "表格",
        "lists": "列表",
        "metrics": "指標",
        "states": "狀態",
        "notifications": "通知",
        "syncModal": "同步彈窗",
        "overlays": "覆蓋層",
        "supportHint": "支援提示",
        "notificationCenter": "通知中心",
        "themes": "主題"
      },
      "logistics": {
        "index": "Logistics",
        "inventories": "Inventories",
        "requests": "Requests",
        "newRequest": "New Request",
        "requestItems": "Items",
        "comments": "Comments",
        "inventoryItems": "Inventory Items",
        "createInventory": "Create Inventory",
        "editInventory": "Edit Inventory",
        "createItem": "Add Item",
        "deposit": "Deposit",
        "withdrawal": "Withdrawal",
        "importCsv": "Import from CSV",
        "hangarInventories": "Hangar Inventories",
        "editItem": "Edit Entry",
        "editStockItem": "Edit Item"
      },
      "notifications": {
        "index": "通知"
      },
      "filterCargoRoutes": "Filter Cargo routes",
      "filterCommodities": "Filter Commodities",
      "starsystems": "Starsystems",
      "starsystem": "%{starsystem} Starsystem",
      "celestialObjects": "Celestial Objects",
      "celestialObject": "%{celestialObject} in the %{starsystem} System",
      "moons": "Moons",
      "stations": "Stations",
      "station": "%{station} near %{celestialObject}",
      "stationImages": "Images of %{station} near %{celestialObject}",
      "shops": "Shops",
      "shop": "%{shop} on %{station}",
      "commodities": "Commodities"
    }
  }
}
